import { filtersHelper } from '@/utils';

export const catalogCategoryModel = (data = {}) => ({
    uuid: data.uuid || '',
    name: data.name || '',
    isActive: data.is_active == null ? true : data.is_active === true || Number(data.is_active) === 1,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
});
